export interface User {
  id: string;
  email: string;
  name: string;
  has_intervalsicu: boolean;
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

export interface AuthResponse {
  access_token: string;
  refresh_token: string;
  user: User;
}

export interface DecodedJWT {
  sub: string;
  exp: number;
  iat?: number;
}

export type AuthStatus = "loading" | "authenticated" | "unauthenticated";

export class AuthError extends Error {
  constructor(
    message: string,
    public code:
      | "INVALID_TOKEN"
      | "REFRESH_FAILED"
      | "NETWORK_ERROR"
      | "GOOGLE_ERROR"
  ) {
    super(message);
    this.name = "AuthError";
  }
}

export interface AuthContextValue {
  status: AuthStatus;
  user: User | null;
  loginWithGoogle: (credential: string) => Promise<void>;
  logout: () => Promise<void>;
  getAccessToken: () => Promise<string>;
  updateUser: (updates: Partial<User>) => void;
}
